<template>
    <img class="object-cover h-full w-full" :src="thumbnail" alt="">
</template>

<script>
import videoInfos from "../../../mixins/video-infos";

export default {
    name: "MoleculeSliderCurrentVideo",
    props: {
        video: Object,
    },
    mixins: [videoInfos],
    watch: {
        video: function (newVideo){
            this.getVideoInfos(newVideo)
        }
    },
    created() {
        this.getVideoInfos(this.video)
    }
}
</script>

<style scoped>

</style>
